// extracted by mini-css-extract-plugin
module.exports = {"title__svg":"ClubAhorroCoupons_title__svg__yAMpw"};